module.exports = __webpack_public_path__ + "img/dash2.40be37ea.png";